import { useEffect, useState } from 'react';

export const useAffiliateId = () => {
  const [affiliateId, setAffiliateId] = useState<string | null>(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const aff = params.get('aff');
    if (aff) setAffiliateId(aff);
  }, []);

  return affiliateId;
};
